import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { whatsappHref } from "../config/site";
import { trackEvent } from "../lib/analytics";

export const WhatsAppFloat = () => {
  const href = whatsappHref("/contact");
  const external = href.startsWith("http");
  const cls =
    "fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-tan text-cream shadow-[0_10px_30px_rgba(45,42,39,0.28)] transition-transform duration-300 hover:scale-105";
  const icon = <MessageCircle size={22} strokeWidth={1.5} />;
  const onClick = () => trackEvent("whatsapp_click", { placement: "floating_button" });
  const label = "Start a WhatsApp Conversation";

  return external ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid="whatsapp-float-cta"
      onClick={onClick}
      className={cls}
    >
      {icon}
    </a>
  ) : (
    <Link
      to={href}
      aria-label={label}
      data-testid="whatsapp-float-cta"
      onClick={onClick}
      className={cls}
    >
      {icon}
    </Link>
  );
};
